import { render } from "./ProjectBimDigitalCompare.vue?vue&type=template&id=3aaaa3be&scoped=true"
import script from "./ProjectBimDigitalCompare.vue?vue&type=script&lang=js"
export * from "./ProjectBimDigitalCompare.vue?vue&type=script&lang=js"

import "./ProjectBimDigitalCompare.vue?vue&type=style&index=0&id=3aaaa3be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaaa3be"]])

export default __exports__
import QBtnToggle from 'quasar/src/components/btn-toggle/QBtnToggle.js';
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtnToggle,QBanner,QSelect,QBtn,QToggle,QTable,QTh,QTr,QTd,QBadge,QIcon,QTooltip});
